export class ServerFilteringTableExportHelper{
    private static counter:number =0;
    private static map:Map<number,any> = new Map<number,any>();
    public static Run(task:(counter)=>any):Promise<any>{
        ServerFilteringTableExportHelper.counter++;
        let counter = ServerFilteringTableExportHelper.counter;
        let newPromise = new Promise((resolve,reject)=>{
            ServerFilteringTableExportHelper.map.set(this.counter,{
                resolve : resolve,
                reject : reject
            });
            task(counter);
        });
        return newPromise;
    }
    public static ResultReceived(key,result,isFailed){
        let mapData = ServerFilteringTableExportHelper.map.get(key);
        ServerFilteringTableExportHelper.map.delete(key);
        if(isFailed){
            mapData.reject({});
        }else{
            mapData.resolve(result);
        }
    }
}